import React from 'react'

export default function RUMLogger({ locale, location }) {
  const pid = location == 'CN' ? 'f8ds5tkidk@e17f6661983d5e8' : 'f8ds5tkidk@bfc9a85e222420d'
  const endpoint = location == 'CN' ? 'https://f8ds5tkidk-default-cn.rum.aliyuncs.com' : 'https://f8ds5tkidk-default-us.rum.aliyuncs.com'

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
        !(function(c,b,d,a){c[a]||(c[a]={});c[a]={
          "pid": "${pid}",
          "endpoint": "${endpoint}",
          "user": {
            name: (function() {
              try {
                var profile = JSON.parse(window.sessionStorage.getItem('profile'));
                return profile.id;
              } catch {
               return null; 
              }
            })(),
            tags: (function() {
              return "${locale} - ${location}";
            })()
          }
        };
        with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
        })(window, document, "https://f8ds5tkidk-sdk.rum.aliyuncs.com/v2/browser-sdk.js", "__rum");
       `,
      }}
    />
  )
}
